export const configurations = {
  hotelSuppliers: ["StayX2", "StayX3"],
  // hotelSuppliers: ["StayX2"],
  hotelSupplierExceptions: [
    "StayX3",
    "StayX1",
    "StayX4",
    "StayX5",
    "StayX6",
    "StayX7",
    "StayX8",
    "StayX9",
    "StayX10",
  ],
  insuranceRecentSearchKey: "insuranceRecentSearch",
  insuranceNoMedicalSuppliers: ["Airhelp Plus"],
  insuranceKeyword: "Protection",
  flightOrderSaveKey: "flightOrder/:id",
  allStatuses: [
    "Pending",
    "Not Paid",
    "Paid",
    "Failed",
    "Booked",
    "Issued",
    "PendingTicketIssue",
    "AwaitingAdmin",
    "Expired",
    "AutoCanceled",
    "Cancelled",
    "CustomerPaid",
    "TicketCanceled",
    "Refunded",
    "TicketCancelationRequested",
  ],
  products: {
    flight: {
      value: "flight",
      alias: "Flight",
    },
    stay: {
      value: "hotel",
      alias: "Accommodation",
    },
    tour: {
      value: "tour",
      alias: "Things to do",
    },
    insurance: {
      value: "insurance",
      alias: "Protection",
    },
  },
  errors: {
    accommodationSearch: "accommodationSearch",
    accommodationAvailbility: "accommodationAvailability",
    accommodationPayment: "accomodationPayment",
    accommodationCancellation: "accomodationCancellation",
    accommodationFareUpdate: "accomodationFareUpdate",
  },
  errorCodes: {
    accommodationNoAvailability: "accommodation-availability-11",
  },
  errorActions: {
    differentHotel: "choose-different-hotel",
  },
  invoice: {
    tabs: {
      invoice: {
        label: "Invoices",
        value: "invoice",
      },
      service: {
        label: "Services",
        value: "service",
      },
      customer: {
        label: "Customers",
        value: "customer",
      },
    },
  },
};
